/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_No_PendingInputs */



/**
* | output |
* | --- |
* | "You have no pending NDA signature request." |
*
* @param {Nda_No_PendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_no_pending = /** @type {((inputs?: Nda_No_PendingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_No_PendingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous n'avez aucune demande de signature de NDA en attente.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No tiene ninguna solicitud de firma de NDA pendiente.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você não tem nenhuma solicitação de assinatura de NDA pendente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non hai richieste di firma dell'NDA in sospeso.")
	return /** @type {LocalizedString} */ ("You have no pending NDA signature request.")
});